import React from "react";
import "../AdminDashboard.css"; // Import the CSS file

const DashboardContent: React.FC = () => {
  return (
    <div style={{ width: "100%" }}>
      {/* Hero Section */}
      <div
        style={{
          borderRadius: "10px",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
          padding: "20px",
          backgroundColor: "#FFF",
          marginBottom: "30px",
        }}
      >
        <div className="hero-main-content" style={{ display: "flex", gap: "20px", alignItems: "stretch" }}>
          <div style={{ flex: "1 1 60%" }}>
            <div
              style={{
                color: "#777",
                fontSize: "18px",
                fontWeight: "700",
                lineHeight: "1",
                letterSpacing: "0.5px",
                marginBottom: "8px",
              }}
            >
              City of New Orleans, E-Bike Incentive Program
            </div>
            <div
              style={{
                color: "#4D4D4D",
                fontSize: "28px",
                fontWeight: "700",
                lineHeight: "1",
                letterSpacing: "0.5px",
                marginBottom: "20px",
              }}
            >
              E-Bike Incentive Program
            </div>

            {/* Stats Cards */}
            <div className="hero-stats-cards" style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
              <div
                className="hero-stat-card"
                style={{
                  borderRadius: "6px",
                  backgroundColor: "rgba(223, 112, 31, 0.2)",
                  display: "flex",
                  // width: "350px", // Adjusted for responsiveness
                  padding: "20px 15px 12px",
                  flexDirection: "column",
                  color: "#DF701F",
                  letterSpacing: "0.5px",
                  flex: "1 1 300px", // Allow cards to grow and shrink
                  minWidth: "250px", // Minimum width before wrapping/stacking
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    lineHeight: "0.8",
                    marginBottom: "15px",
                  }}
                >
                  224
                </div>
                <div
                  style={{
                    display: "flex",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "1",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <div>Pending Consumer Applications</div>
                  <div style={{ width: "20px", height: "20px" }}>→</div>
                </div>
              </div>

              <div
                className="hero-stat-card"
                style={{
                  borderRadius: "6px",
                  backgroundColor: "rgba(223, 112, 31, 0.2)",
                  display: "flex",
                  // width: "350px", // Adjusted for responsiveness
                  padding: "20px 15px 12px",
                  flexDirection: "column",
                  color: "#DF701F",
                  letterSpacing: "0.5px",
                  flex: "1 1 300px", // Allow cards to grow and shrink
                  minWidth: "250px", // Minimum width before wrapping/stacking
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "700",
                    lineHeight: "0.8",
                    marginBottom: "15px",
                  }}
                >
                  162
                </div>
                <div
                  style={{
                    display: "flex",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "1",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <div>Pending Bike Shop Reimbursements</div>
                  <div style={{ width: "20px", height: "20px" }}>→</div>
                </div>
              </div>
            </div>
          </div>

          {/* Hero Image */}
          <div className="hero-image-container" style={{ flex: "1 1 40%" }}>
            <img
              src="/images/main-bike-image.png"
              alt="E-Bike Program"
              style={{
                width: "100%",
                height: "200px",
                borderRadius: "0px 10px 10px 0px",
                maxWidth: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      </div>

      {/* Program Statistics Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "13px",
          fontSize: "20px",
          color: "#4D4D4D",
          fontWeight: "700",
          letterSpacing: "0.5px",
          lineHeight: "0.8",
          marginBottom: "34px",
        }}
      >
        <div>Program Statistics</div>
        <div
          style={{
            flex: 1,
            height: "1px",
            backgroundColor: "#CCC",
          }}
        />
      </div>

      {/* Statistics Section */}
      <div
        className="admin-stats-container" // Added class for potential specific styling
        style={{
          borderRadius: "10px",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
          marginBottom: "30px",
          padding: "22px 220px 22px 22px", // Adjusted padding for responsiveness
          backgroundColor: "#FFF",
        }}
      >
        <div className="admin-stats-grid" style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          {/* Left Section */}
          <div className="admin-stats-column" style={{ flex: 1, minWidth: "200px" }}>
            <div style={{ display: "flex", gap: "40px" }} className="admin-stats-column-content">
              <div>
                <div
                  style={{
                    fontSize: "16px",
                    color: "#4D4D4D",
                    fontWeight: "700",
                    letterSpacing: "0.5px",
                    lineHeight: "1",
                    marginBottom: "52px",
                  }}
                >
                  Consumer Applications by Status
                </div>
                <div style={{ textAlign: "center" }}>
                  <div
                    style={{
                      color: "#4979A7",
                      fontSize: "32px",
                      fontWeight: "700",
                      lineHeight: "0.5",
                      marginBottom: "20px",
                    }}
                  >
                    876
                  </div>
                  <div
                    style={{
                      color: "#4D4D4D",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "1",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Total Applications Submitted
                  </div>
                </div>
              </div>

              <div
                style={{
                  borderLeft: "1px solid #CCC",
                  paddingLeft: "100px",
                }}
              >
                {/* Pending Status */}
                <div style={{ marginBottom: "40px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "4px",
                        backgroundColor: "rgba(249, 226, 210, 1)",
                        display: "flex",
                        padding: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                      }}
                    >
                      <img
                        src="/images/pending-icon.svg"
                        alt="Pending"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "20px",
                          fontWeight: "700",
                          lineHeight: "0.8",
                          marginBottom: "12px",
                        }}
                      >
                        224
                      </div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Pending
                      </div>
                    </div>
                  </div>
                </div>

                {/* Approved Status */}
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "4px",
                        backgroundColor: "#E6F4FF",
                        display: "flex",
                        padding: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                      }}
                    >
                      <img
                        src="/images/approved-icon.svg"
                        alt="Approved"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "20px",
                          fontWeight: "700",
                          lineHeight: "0.8",
                          marginBottom: "12px",
                        }}
                      >
                        291
                      </div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Approved
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Middle Section */}
          <div className="admin-stats-column" style={{ minWidth: "150px" }}>
            <div style={{ marginBottom: "40px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    borderRadius: "4px",
                    backgroundColor: "#FFF1F0",
                    display: "flex",
                    padding: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "44px",
                    height: "44px",
                  }}
                >
                  <img
                    src="/images/sale-progress-icon.svg"
                    alt="Sale In Progress"
                    style={{ width: "24px", height: "24px" }}
                  />
                </div>
                <div>
                  <div
                    style={{
                      color: "#4D4D4D",
                      fontSize: "20px",
                      fontWeight: "700",
                      lineHeight: "0.8",
                      marginBottom: "12px",
                    }}
                  >
                    82
                  </div>
                  <div
                    style={{
                      color: "#4D4D4D",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "1",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Sale In Progress
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    borderRadius: "4px",
                    backgroundColor: "#FFFBE6",
                    display: "flex",
                    padding: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "44px",
                    height: "44px",
                  }}
                >
                  <img
                    src="/images/redeemed-icon.svg"
                    alt="Redeemed"
                    style={{ width: "24px", height: "24px" }}
                  />
                </div>
                <div>
                  <div
                    style={{
                      color: "#4D4D4D",
                      fontSize: "20px",
                      fontWeight: "700",
                      lineHeight: "0.8",
                      marginBottom: "12px",
                    }}
                  >
                    22
                  </div>
                  <div
                    style={{
                      color: "#4D4D4D",
                      fontSize: "16px",
                      fontWeight: "400",
                      lineHeight: "1",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Redeemed
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className="admin-stats-column" style={{ minWidth: "200px" }}> {/* Adjusted minWidth */}
            <div style={{ display: "flex", gap: "20px" }} className="admin-stats-column-content"> {/* Reduced gap */}
              <div>
                <div style={{ marginBottom: "40px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "4px",
                        backgroundColor: "#F6FFED",
                        display: "flex",
                        padding: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                      }}
                    >
                      <img
                        src="/images/funded-icon.svg"
                        alt="Funded"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "20px",
                          fontWeight: "700",
                          lineHeight: "0.8",
                          marginBottom: "12px",
                        }}
                      >
                        208
                      </div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Funded
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "4px",
                        backgroundColor: "#F9F0FF",
                        display: "flex",
                        padding: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                      }}
                    >
                      <img
                        src="/images/waitlisted-icon.svg"
                        alt="Waitlisted"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "20px",
                          fontWeight: "700",
                          lineHeight: "0.8",
                          marginBottom: "12px",
                        }}
                      >
                        0
                      </div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Waitlisted
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div style={{ marginBottom: "40px" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "4px",
                        backgroundColor: "#FFF0F6",
                        display: "flex",
                        padding: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                      }}
                    >
                      <img
                        src="/images/declined-icon.svg"
                        alt="Declined"
                        style={{ width: "24px", height: "24px" }}
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "20px",
                          fontWeight: "700",
                          lineHeight: "0.8",
                          marginBottom: "12px",
                        }}
                      >
                        37
                      </div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Declined
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "4px",
                        backgroundColor: "#EEE",
                        display: "flex",
                        padding: "10px",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "44px",
                        height: "44px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "16px",
                          fontWeight: "700",
                          color: "#4D4D4D",
                        }}
                      >
                        12
                      </div>
                    </div>
                    <div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "20px",
                          fontWeight: "700",
                          lineHeight: "0.8",
                          marginBottom: "12px",
                        }}
                      >
                        12
                      </div>
                      <div
                        style={{
                          color: "#4D4D4D",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "1",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Expired
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Charts Section */}
      <div className="admin-charts-row">
        {/* Ethnicity Chart */}
        <div className="admin-chart-card">
          <div className="admin-chart-content" style={{ display: "flex", gap: "20px" }}> {/* Added admin-chart-content class */}
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: "16px",
                  color: "#4D4D4D",
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  lineHeight: "1",
                  marginBottom: "30px",
                }}
              >
                Consumer Applications by Ethnicity
              </div>
              <img
                src="/images/pie-chart-ethnicity.png"
                alt="Ethnicity Chart"
                style={{
                  width: "300px",
                  height: "auto",
                  borderRadius: "8px",
                }}
              />
            </div>
            <div style={{ flex: 1, marginTop: "auto", marginBottom: "auto" }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                {[
                  { color: "rgba(47, 77, 106, 1)", label: "Hispanic/Latino" },
                  { color: "rgba(255, 141, 135, 1)", label: "Black or African American" },
                  { color: "rgba(255, 222, 89, 1)", label: "American Indian or Alaska Native" },
                  { color: "rgba(123, 104, 238, 1)", label: "Native Hawaiian or Other Pacific Islander" },
                  { color: "rgba(80, 227, 194, 1)", label: "Native American or Alaska Native" },
                  { color: "rgba(245, 166, 35, 1)", label: "White or Caucasian" },
                  { color: "rgba(169, 169, 169, 1)", label: "Asian or Asian American" },
                  { color: "rgba(223, 112, 31, 1)", label: "A race/ethnicity not listed here" },
                ].map((item, index) => (
                  <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        backgroundColor: item.color,
                        borderRadius: "4px",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "16px",
                        color: "#4D4D4D",
                        fontWeight: "400",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Income Chart */}
        <div className="admin-chart-card">
          <div
            // className="admin-chart-card" // This was likely a copy-paste error, the outer div is already admin-chart-card
            style={{
              // borderRadius: "10px", // These styles belong to admin-chart-card, not this inner div
              // boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.2)",
              flex: "1",
              // padding: "27px",
              // backgroundColor: "#fff",
              minWidth: "300px", // This might also be better on the card or handled by flex
            }}
          >
            <div className="admin-chart-content" style={{ display: "flex", gap: "20px" }}> {/* Added admin-chart-content class */}
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "16px",
                    color: "#4D4D4D",
                    fontWeight: "700",
                    letterSpacing: "0.5px",
                    lineHeight: "1",
                    marginBottom: "30px",
                  }}
                >
                  Consumer Applications by Household Income
                </div>
                <img
                  src="/images/pie-chart-income.png"
                  alt="Income Chart"
                  style={{
                    width: "300px",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </div>
              <div style={{ flex: 1, marginTop: "auto", marginBottom: "auto" }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {[
                    { color: "rgba(47, 77, 106, 1)", label: "$0 - $29,999" },
                    { color: "rgba(255, 141, 135, 1)", label: "$30,000 - $59,999" },
                    { color: "rgba(73, 121, 167, 1)", label: "$60,000 - $119,999" },
                    { color: "rgba(223, 112, 31, 1)", label: "$120,000 +" },
                  ].map((item, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: item.color,
                          borderRadius: "4px",
                        }}
                      />
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#4D4D4D",
                          fontWeight: "400",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {item.label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Participating Bike Shops Table */}
      <div
        className="admin-table-container" // Added class for table responsiveness
        style={{
          borderRadius: "10px",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
          backgroundColor: "#FFF",
          padding: "20px",
          overflowX: "auto", // Make table scrollable on small screens
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "end",
            gap: "100px",
            marginBottom: "44px",
          }}
        >
          <div>
            <div
              style={{
                color: "#4D4D4D",
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "1",
                marginBottom: "28px",
              }}
            >
              Participating Bike Shops
            </div>
            <div
              style={{
                color: "rgba(170, 170, 170, 1)",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "1",
              }}
            >
              Bike Shop
            </div>
          </div>
          <div style={{ display: "flex", gap: "95px" }}>
            <div
              style={{
                color: "rgba(170, 170, 170, 1)",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "1",
                textAlign: "center",
              }}
            >
              Redeemed
            </div>
            <div
              style={{
                color: "rgba(170, 170, 170, 1)",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "1",
                textAlign: "center",
              }}
            >
              Funded
            </div>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            fontSize: "16px",
            color: "#4D4D4D",
            gap: "100px",
          }}
        >
          <div style={{ flex: 1 }}>
            {[
              "Sample Bike Shop",
              "Sample Bike Shop",
              "Sample Bike Shop",
              "Sample Bike Shop",
              "Sample Bike Shop",
              "Sample Bike Shop",
              "Sample Bike Shop",
              "Sample Bike Shop",
            ].map((shop, index) => (
              <div
                key={index}
                style={{ marginBottom: "20px", fontWeight: "400" }}
              >
                {shop}
              </div>
            ))}
          </div>
          <div style={{ textAlign: "center", fontWeight: "700" }}>
            {[138, 150, 205, 74, 61, 58, 114, 76].map(
              (redeemed, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                  {redeemed}
                </div>
              ),
            )}
          </div>
          <div style={{ textAlign: "center", fontWeight: "700" }}>
            {[102, 133, 184, 66, 54, 41, 110, 67].map(
              (funded, index) => (
                <div key={index} style={{ marginBottom: "20px" }}>
                  {funded}
                </div>
              ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;
